import { render, staticRenderFns } from "./InfoCard2.vue?vue&type=template&id=d0939382&scoped=true&"
import script from "./InfoCard2.vue?vue&type=script&lang=js&"
export * from "./InfoCard2.vue?vue&type=script&lang=js&"
import style0 from "./InfoCard2.vue?vue&type=style&index=0&id=d0939382&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0939382",
  null
  
)

export default component.exports